/** Takes in a regular hex color like #fff or #000000 and an
 * alpha value and returns that color as RGBA(color,,,alpha)
 *
 * @constant
 * @param hexColor a color hex code string such as #111 or #123456
 * @param alpha decimal value to set alpha (transparancy level) to
 * @returns {string}
 */
export const setColorAlpha = (hexColor, alpha) => {
    try {
        const hex = hexColor.replace('#', '');
        if (hex.length !== 3 && hex.length !== 6) {
            return hex;
        }
        const short = (hex === null || hex === void 0 ? void 0 : hex.length) === 3;
        const r = parseInt(short ? hex.slice(0, 1).repeat(2) : hex.slice(0, 2), 16);
        const g = parseInt(short ? hex.slice(1, 2).repeat(2) : hex.slice(2, 4), 16);
        const b = parseInt(short ? hex.slice(2, 3).repeat(2) : hex.slice(4, 6), 16);
        if (alpha) {
            return 'RGBA(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
        }
        else {
            return 'RGB(' + r + ', ' + g + ', ' + b + ')';
        }
    }
    catch (error) {
        return hexColor;
    }
};
